import { QuestionAnswerPairsPublic } from "./base.types"
import { ImageUploadPublic } from "./image.types";
import { ShippoUser } from "./thirdPartyTypes";

export const _EMAIL_ADDRESS_FOR_TESTING_SUCCESSFULLY_SEGMENT_VERIFIED = "greg.a.howle+verified@gmail.com"
export const _EMAIL_ADDRESS_FOR_TESTING_FAILED_SEGMENT_USER_CREATION = "fail@test.com";
export const AUTHORIZED_ACCOUNT_LABEL = "Authorized Account"

export const COLLECTION_PATH_ACCOUNT_CONFIG = "locationAccountConfig"; // [ ] change to locationAccountState
export type LocCreationMode = "start" | "creating record" | "attaching address" | "logging details" | "initiating payment processor" | "waiting for response" | "complete"

export type AddressType = 'shipping' | 'physical' | 'billing';

export interface AddressInfo {
  attn?: string
  streetNumber: string
  address: string
  address2: string
  city: string
  state: string
  postcode: string
}

export interface UpdateAddressVariables {
  id: string ;
  attn: string ;
  streetNumber: string ;
  address: string;
  city: string;
  state: string;
  postcode: string;
  validationId: string ;
  validationStatus: string ;
  locationId: string;
}

export interface SegmentPublic {
  id: number
  name: string
  subdomain: string
  shortDescription: string
  description: string
  verifiedLocationNoun: string
  imageUrl: string
  segmentRegistrationRequirements?: SegmentRegistrationRequirementPublic[]
  locationQuestions?: LocationQuestionPublic[]
}

export interface SegmentRegistrationRequirementPublic {
  id: string
  ruleDescription: string
  requirementType: string
  requirementValue: string
  userMustMeet: boolean
  verifiedUserMustMeet: boolean
  displayRuleDescription: boolean
  sortOrder?: number | null | undefined
}

export interface LocationQuestionPublic {
  questionLabel: string
  questionType: string
  questionOptions: string[]
  displayLabel: string
  isMandatory: boolean
  sortOrder: number
  displayOnListing: boolean
  locationQuestionOptions_on_locationQuestion: {
      id: string;
      optionText: string;
      optionValue: string;
      sortOrder: number;
    }[]
}

export interface LocationPublic {
  id: string
  name: string
  segmentId?: number
  description: string
  owner: {
    displayName: string
  }
  verified: boolean
  profileImage?: ImageUploadPublic
  locationAnswers_on_location: QuestionAnswerPairsPublic[];
  shippoUsers_on_location: ShippoUser[]
  shippingAddress?: AddressPublic
  physicalAddress?: AddressPublic
}

export interface LocationPrivate extends LocationPublic {
  shippingAddress: AddressPublic
  physicalAddress: AddressPublic
}

export interface AddressPublic {
  id: string
  googlePlaceId: string
  attn?: string
  streetNumber: string
  address: string
  city: string 
  state: string 
  postcode: string
}

export interface FireStoreStripeAccountRecord { // [ ] change to FireStoreLocationAccountStoreRecord
  locationId: string
  accountId: string // [ ] change to stripeAccountId
  customerId: string
  chargesEnabled: boolean
  transfersEnabled: boolean
  detailsSubmitted: boolean
  defermentPaid: boolean
  currentOnboardingLink: FireStoreStripeAccountRecordOnboardingLink
  interactionCount: number
  locationName?: string
}
export interface FireStoreStripeAccountRecordOnboardingLink {
  created: number
  expires_at: number
  object: string
  url: string
}

export interface ConsumeInvitationRequest {
  invitationId: string
  skipMakeDefault?: boolean
}
